const tools = require('../../tools')
const { getFullServiceID } = require('../../../tools/utils')

function shouldFetchConfigurations (location = {}) {
  return Array.isArray(location.services) && location.services.length > 0
}

// `allConfigurations` is consumed inside `docToEntity` only by
// `getSupplierRelationships`, which short-circuits for any program other than
// `shelflife` (see api/lib/tools/location-docs.js). Fetching configs for
// other programs (e.g. PSM's malaria) wastes a round-trip and bloats the
// keyed `_all_docs` request, so we restrict the derivation to shelflife.
//
// If `getSupplierRelationships` ever starts caring about more programs, lift
// the SHELFLIFE_PROGRAM_KEY check below in lockstep.
const SHELFLIFE_PROGRAM_KEY = 'shelflife'

/**
 * Derives CouchDB configuration document IDs directly from raw location docs
 * (`doc.programs`), in the format
 * `configuration:program:shelflife:service:<shortServiceId>`.
 *
 * Reading from raw docs (instead of hydrated entities) lets callers fetch
 * configurations before building entities, so `docToEntity` can be invoked
 * once with the real configs rather than running a second post-processing pass.
 */
function getConfigurationIdsFromDocs (docs = []) {
  const seen = Object.create(null)
  for (let i = 0; i < docs.length; i++) {
    const doc = docs[i]
    if (!doc || !doc.programs) continue
    const services = doc.programs[SHELFLIFE_PROGRAM_KEY]
    if (!services) continue
    for (const serviceKey in services) {
      // Cheap dedupe avoids re-formatting the full configuration ID
      // for every doc that shares the same service.
      if (seen[serviceKey]) continue
      seen[serviceKey] = `configuration:${getFullServiceID(serviceKey, SHELFLIFE_PROGRAM_KEY)}`
    }
  }
  return Object.values(seen)
}

exports.getConfigurationIdsFromDocs = getConfigurationIdsFromDocs
exports.shouldFetchConfigurations = shouldFetchConfigurations

exports.getLocationsWithConfigurations = async (state, docs = [], options = {}) => {
  const validDocs = docs.filter(Boolean)
  const configurationIds = getConfigurationIdsFromDocs(validDocs)

  const allConfigurations = configurationIds.length
    ? await state.dal.configuration.list(state, configurationIds)
    : []

  return validDocs.map(doc => tools.docToEntity({
    doc,
    allConfigurations,
    ...options
  }))
}
